module.exports = __webpack_public_path__ + "media/images/rt_monogram-b885e1a537420a2d758ad4d2a19a7e65.svg";